import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { updatePage, deletePage, createPage } from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	CREATE: 'event/:eventID/pages/POST',
	DELETE: 'event/:eventID/pages/:pageID/DELETE',
	UPDATE: 'event/:eventID/pages/:pageID/PATCH',
};

const PageSubscriptions = props => {
	const { socket, updatePage, createPage, deletePage, currentEventId } = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		console.log('⚡️ PageSubscriptions Mounted ⚡️');
		socket.emit('event/:eventID/pages/SUBSCRIBE', { eventID: currentEventId });
	};

	const unsubscribe = () => {
		console.log(`🚶‍♂️ PageSubscriptions Unmounted 🚶‍♂️`);
		socket.emit('event/:eventID/pages/UNSUBSCRIBE', { eventID: currentEventId });
	};

	const listenForUpdatedPage = () => {
		socket.on(WS_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating page', error);
			else {
				updatePage(data);
				displayMessage('Page saved');
			}
		});
	};

	const listenForDeletedPage = () => {
		socket.on(WS_EVENTS_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error deleting page', error);
			else {
				deletePage(data);
				displayMessage('Page deleted');
			}
		});
	};

	const listenForCreatedPage = () => {
		socket.on(WS_EVENTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error creating page', error);
			else {
				createPage(data);
				displayMessage('Page created');
			}
		});
	};

	const listeners = () => [listenForCreatedPage, listenForDeletedPage, listenForUpdatedPage];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
				from="page"
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	updatePage: page => dispatch(updatePage(page)),
	deletePage: pageID => dispatch(deletePage(pageID)),
	createPage: page => dispatch(createPage(page)),
});

export default connect(msp, mdp)(PageSubscriptions);
